<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card class="white pa-7 rounded-of">
      <div class="text-right">
        <v-btn color="primary subtitle-1 rounded-of px-4 py-4 removetexttransform" dark depressed @click="dialog = false">Close</v-btn>
      </div>
      <v-row class="white">
        <v-col cols="12">
          <div class="title black--text text-center">Add 2GoCup Location</div>
        </v-col>
        <v-col cols="12">
          <TextField v-model.trim="form.name" label="Name" background="lightgrey" makedense />
        </v-col>
        <v-col cols="12">
          <TextField v-model.trim="form.description" label="Description" background="lightgrey" makedense />
        </v-col>
        <v-col cols="12">
          <TextField v-model.trim="form.phone" label="Phone" background="lightgrey" makedense />
        </v-col>
        <v-col cols="12">
          <vuetify-google-autocomplete
            id="togocup-location" 
            name="togocup-location"
            classname="form-control"
            ref="addressInput"
            :clearable="true"
            :country="['gb']"
            types="address"
            v-on:placechanged="getAddressData"
            placeholder="Enter a location"
            background-color="lightgrey"
            autocomplete="off"
            solo
          />
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary removetexttransform" @click="addLocation">
          {{ editingId ? 'Save Changes' : 'Add Location' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddToGoCupLocationDialog",
  data() {
    return {
      dialog: false,
      form: {
        name: '',
        description: '',
        phone: '',
        streetaddress: '',
        loc_lat: null,
        loc_long: null,
      },
      editingId: null,
    };
  },
  computed: {
      ...mapGetters({
          GET_currentUserProfile: "GET_currentUserProfile",
      }),
  },
  methods: {
    getAddressData(addressData, placeResultData) {
      let placeResult = this.MIX_googlePlacesConversion(JSON.stringify(placeResultData));
      this.form.streetaddress = placeResult.addressLine1 + (placeResult.addressLine2 ? ', ' + placeResult.addressLine2 : '') + (placeResult.town ? ', ' + placeResult.town : '') + (placeResult.county ? ', ' + placeResult.county : '') + (placeResult.postcode ? ', ' + placeResult.postcode : '');
      this.form.loc_lat = placeResult.lat;
      this.form.loc_long = placeResult.lng;
    },
    async addLocation() {
      if (!this.form.name || !this.form.streetaddress || !this.form.loc_lat || !this.form.loc_long) {
        this.$root.MIX_alertBox({ show: true, message: 'Please fill in all required fields and select a valid address.', color: 'error', timeout: '4000' });
        return;
      }
      const userId = this.GET_currentUserProfile.entityId || null;
      const now = Math.floor(Date.now() / 1000); // unix seconds
      if (this.editingId) {
        // Editing existing location
        const updateData = {
          ...this.form,
          modifiedBy: userId,
          modifiedDateTime: now,
        };
        // Remove id from updateData if present
        if (updateData.id) delete updateData.id;
        await this.REDIS_update("togocuplocation", this.editingId, updateData);
        this.$emit('location-edited');
      } else {
        // Creating new location
        const formWithUser = { 
          ...this.form, 
          createdBy: userId, 
          modifiedBy: userId,
          deletedBy: null
        };
        await this.REDIS_create("togocuplocation", formWithUser);
        this.$emit('location-added');
      }
      this.dialog = false;
      this.form = { name: '', description: '', phone: '', streetaddress: '', loc_lat: null, loc_long: null };
      this.editingId = null;
      // Clear the vuetify-google-autocomplete input
      if (this.$refs.addressInput && this.$refs.addressInput.clear) {
        this.$refs.addressInput.clear();
      }
    },
    async editLocation() {
      const id = this.editingId;
      if (!id) return;
      const userId = this.GET_currentUserProfile?.entityId || null;
      const now = Math.floor(Date.now() / 1000); // unix seconds
      await this.REDIS_update("togocuplocation", id, {
        ...this.form,
        modifiedBy: userId,
        modifiedDateTime: now,
      });
      this.$emit('location-edited');
      this.dialog = false;
    },
    open(location) {
      this.dialog = true;
      if (location) {
        this.editingId = location.id || null;
        // Defensive: ensure editingId is string or number, not object
        if (typeof this.editingId === 'object' && this.editingId !== null) {
          this.editingId = this.editingId.toString();
        }
        this.form = { ...location };
      } else {
        this.editingId = null;
        this.form = { name: '', description: '', phone: '', streetaddress: '', loc_lat: null, loc_long: null };
      }
    },
  },
};
</script>
<style scoped>
:deep(.v-input__slot) {
  padding: 0 12px !important;
}
</style>
